import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { GetCaseCommentHistory } from "../../api/api";

type CaseCommentHistoryResult = {
  status: string;
  msg: Array<{
    updatedBy: string;
    updatedAt: string;
    comment: string;
  }>;
};

type CaseCommentHistoryInput = {
  caseId: string;
};

export const useCaseCommentHistory = () => {
  const { getAccessTokenSilently } = useAuth0();

  const queryWithToken = useCallback(
    async ({ caseId }: CaseCommentHistoryInput): Promise<CaseCommentHistoryResult> => {
      const token = await getAccessTokenSilently();
      return GetCaseCommentHistory({
        authToken: token,
        body: { caseId },
      });
    },
    [getAccessTokenSilently]
  );

  return {
    queryWithToken,
  };
};

export const useGetCaseCommentHistory = (caseId: string | null, enabled: boolean = true) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: ["caseCommentHistory", caseId],
    queryFn: async (): Promise<CaseCommentHistoryResult> => {
      if (!caseId) {
        throw new Error("Case ID is required");
      }
      const token = await getAccessTokenSilently();
      console.log("Calling GetCaseCommentHistory with:", { caseId, token: token ? "present" : "missing" });
      return GetCaseCommentHistory({
        authToken: token,
        body: {
          caseId,
          pagination: {
            limit: 10,
            skip: 0
          }
        },
      });
    },
    enabled: enabled && !!caseId && isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
